import { apiClient } from '@/services/apiClient';
import { useMutation } from '@tanstack/react-query';
import type { ThreeDSCompleteResponse } from '@/types/payment';
import { Routes } from './routes';

interface ThreeDSCompleteParams {
  paymentAttemptId: string;
}

/**
 * Called once a Forter-orchestrated 3DS challenge resolves successfully.
 * Returns the same payload as `/finalize-payment` (see
 * {@link ThreeDSCompleteResponse}), so callers feed it back through
 * `handlePaymentResults` to dispatch on the PSP-specific outcome.
 */
export const useThreeDSComplete = () => {
  return useMutation({
    mutationFn: async (params: ThreeDSCompleteParams): Promise<ThreeDSCompleteResponse> => {
      return apiClient.post<ThreeDSCompleteResponse>(Routes.THREE_DS_COMPLETE, {
        paymentAttemptId: params.paymentAttemptId,
      });
    },
  });
};
